import { Component, Input } from '@angular/core';
import { enumDetailedInfoPlacementEnum } from '@app/data-layer/enums/lcl';
import { QuoteModel } from '@data-layer/models/lcl';

@Component({
  selector: 'app-lcl-header',
  template: `
    <header class="lcl-header">
      <div class="lcl-header-common-info">
        <div class="lcl-header-common-info-col">
          <p>{{ 'LABELS.QUOTE_ID' | translate }}</p>
          <span>{{ quote.referenceNumber }}</span>
        </div>

        <div class="lcl-header-common-info-col" *ngIf="quote?.voyage?.validityDate">
          <p>{{ 'LABELS.QUOTE_VALIDITY' | translate }}</p>
          <span>{{ quote?.voyage?.validityDate | date : formatDateTime }}</span>
        </div>
      </div>

      <app-lcl-header-detailed-info
        [template]="enumDetailedInfoPlacementEnum.quoteTemplate"
        [isQuote]="true"
        [info]="quote"
        [isHideIncoterms]="isHideIncoterms"
      ></app-lcl-header-detailed-info>
    </header>
  `,
  styleUrls: ['./lcl-header.component.scss'],
})
export class LclHeaderComponent {
  @Input() public quote: QuoteModel;
  @Input() public isHideIncoterms: boolean;

  public formatDateTime: string = 'MM/dd/yyyy';
  public enumDetailedInfoPlacementEnum: typeof enumDetailedInfoPlacementEnum = enumDetailedInfoPlacementEnum;
}
